/**
 * MapScreen — top-level shell for the / index route. Wraps MapView so the
 * Outlet rendering pattern in App.tsx stays declarative.
 *
 * MapView owns the WebGL canvas + chrome; this screen exists primarily so
 * App.tsx points at a route element rather than a directly-imported feature.
 */
import { MapView } from "../features/map/MapView";

export function MapScreen() {
  return <MapView />;
}
